import { render, staticRenderFns } from "./PackageGeneral.vue?vue&type=template&id=b2536d74&"
import script from "./PackageGeneral.vue?vue&type=script&lang=js&"
export * from "./PackageGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PackageGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageGeneral.vue"
export default component.exports